/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Location = {
    readonly id?: number;
    city?: string | null;
    phone1?: string | null;
    phone2?: string | null;
    state?: string | null;
    street?: string | null;
    street2?: string | null;
    zipcode?: string | null;
    /**
     * fax number to be presented on report. No faxes will be sent here by the system.
     */
    fax?: string | null;
    /**
     * The specific name of the US timezone. Please prefer state based options of Alaska and Arizona when appropriate.
     */
    timezone?: Location.timezone | null;
}

export namespace Location {

    /**
     * The specific name of the US timezone. Please prefer state based options of Alaska and Arizona when appropriate.
     */
    export enum timezone {
        US_ALASKA = 'US/Alaska',
        US_ARIZONA = 'US/Arizona',
        US_CENTRAL = 'US/Central',
        US_EASTERN = 'US/Eastern',
        US_HAWAII = 'US/Hawaii',
        US_MOUNTAIN = 'US/Mountain',
        US_PACIFIC = 'US/Pacific',
    }


}
